const state = {
  active: false,
  complete: false
}

export default state



// WEBPACK FOOTER //
// ./assets/js/store/modules/splash/state.js